import * as swcHelpers from '@swc/helpers';
import { isLineItemReorderable } from '../../../utils/is-line-item-reorderable.js';
import { createImageUrl } from '../utils/create-image-url.js';
import '../utils/get-payment-status-label.js';
import { getPrices } from '../utils/get-prices.js';
import { getProductA11yLabel } from '../utils/get-product-a11y-label.js';
import { getProductSubtitle } from '../utils/get-product-subtitle.js';
import { getProductTitle } from '../utils/get-product-title.js';

const mapProductType = (serverType)=>{
    switch(serverType.toLowerCase()){
        case 'frames':
            return 'frames';
        case 'sunglasses':
            return 'sunglasses';
        case 'solutions':
            return 'solutions';
        case 'ready_readers':
            return 'ready-readers';
        case 'accessories':
            return 'accessories';
        default:
            return 'sunglasses';
    }
};
const toBaseLineItem = (orderLineItem, intl, options = {})=>{
    var ref, ref1;
    const priceDetails = getPrices(orderLineItem);
    var ref2, ref3;
    return swcHelpers.objectSpread({
        id: orderLineItem.id,
        lineItemId: orderLineItem.id,
        productType: mapProductType(orderLineItem.product.productType),
        // TODO: MACC-15487 - Remove originalProductType once we have a proper solution for the productType mapping
        originalProductType: mapProductType(orderLineItem.product.productType),
        quantity: `${intl.getLabel('cart.item.quantity')}: ${orderLineItem.quantity}`,
        sku: orderLineItem.product.sku,
        isSkuPublished: (ref2 = (ref = orderLineItem.product.currentProduct) === null || ref === void 0 ? void 0 : ref.published) !== null && ref2 !== void 0 ? ref2 : false,
        imageUrl: createImageUrl(orderLineItem.product.mainImage, options),
        title: getProductTitle(orderLineItem, intl),
        subtitle: getProductSubtitle(orderLineItem, intl),
        altText: getProductA11yLabel(orderLineItem, intl),
        isReorderAvailable: isLineItemReorderable(orderLineItem),
        slug: (ref3 = (ref1 = orderLineItem.product.currentProduct) === null || ref1 === void 0 ? void 0 : ref1.slug) !== null && ref3 !== void 0 ? ref3 : undefined,
        insurance: orderLineItem.insurance,
        deliveryEstimation: orderLineItem.deliveryEstimation
    }, priceDetails);
};

export { toBaseLineItem };
//# sourceMappingURL=base-line-item.js.map
